import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ReactNode } from 'react';
import {
  clearFavorites,
  getFavorites,
  removeFavorite,
  saveFavorite,
} from '../thunks/favouriteThunk.ts';

interface Favorite {
  jobId: string;
  createdAt: string;
  _id: string;
  jobcategory: ReactNode;
  jobtitle: ReactNode;
  jobdescription: ReactNode;
  location: ReactNode;
  joboffer: ReactNode;
  startdate: string;
  userId: string;
}

interface FavoritesState {
  [x: string]: any;
  items: Favorite[];
  loading: boolean;
  error: string | null;
}

const initialState: FavoritesState = {
  items: [],
  loading: false,
  error: null,
};

const favoritesSlice = createSlice({
  name: 'favorites',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(saveFavorite.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        saveFavorite.fulfilled,
        (state, action: PayloadAction<Favorite>) => {
          state.loading = false;
          state.items.push(action.payload);
        },
      )
      .addCase(saveFavorite.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });

    // Get Favorites
    builder
      .addCase(getFavorites.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        getFavorites.fulfilled,
        (state, action: PayloadAction<{ favorites: Favorite[] }>) => {
          state.loading = false;
          state.items = action.payload.favorites;
        },
      )
      .addCase(getFavorites.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });

    // Remove Favorite
    builder
      .addCase(removeFavorite.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        removeFavorite.fulfilled,
        (
          state,
          action: PayloadAction<{
            jobId: string;
            postId: string;
          }>,
        ) => {
          state.loading = false;
          state.items = state.items.filter(
            (fav) => fav.jobId !== action.payload.jobId,
          );
        },
      )
      .addCase(removeFavorite.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });

    builder
      .addCase(clearFavorites.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(clearFavorites.fulfilled, (state) => {
        state.loading = false;
        state.items = [];
      })
      .addCase(clearFavorites.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default favoritesSlice.reducer;
